(function() {
  var selector = '[data-rt-product-carousel]';

  function setup(root) {
    if (!root || root.getAttribute('data-rt-carousel-ready') === 'true') return;

    var scroller = root.querySelector('[data-rt-product-carousel-scroller]');
    var prev = root.querySelector('[data-rt-carousel-prev]');
    var next = root.querySelector('[data-rt-carousel-next]');
    if (!scroller || !prev || !next) return;

    root.setAttribute('data-rt-carousel-ready', 'true');

    function pageSize() {
      return scroller.clientWidth;
    }

    function updateButtons() {
      var max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      prev.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= max - 2;
    }

    prev.addEventListener('click', function() {
      scroller.scrollBy({ left: -pageSize(), behavior: 'smooth' });
    });
    next.addEventListener('click', function() {
      scroller.scrollBy({ left: pageSize(), behavior: 'smooth' });
    });
    scroller.addEventListener('scroll', updateButtons, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateButtons).observe(scroller);
    } else {
      window.addEventListener('resize', updateButtons);
    }

    updateButtons();
  }

  function init(scope) {
    var roots;
    if (scope && scope.querySelectorAll) {
      roots = scope.querySelectorAll(selector);
      if (scope.matches && scope.matches(selector)) {
        setup(scope);
      }
    } else {
      roots = document.querySelectorAll(selector);
    }

    for (var i = 0; i < roots.length; i++) {
      setup(roots[i]);
    }
  }

  function sync(root, cardCount) {
    if (!root) return;

    if (cardCount > 4) {
      root.setAttribute('data-rt-product-carousel', '');
      setup(root);
    } else {
      root.removeAttribute('data-rt-product-carousel');
    }
  }

  window.theme = window.theme || {};
  theme.productCarousel = {
    init: init,
    setup: setup,
    sync: sync
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    init(event.target);
  });

  document.addEventListener('recommendations:loaded', function(event) {
    var section = event.detail && event.detail.section;
    if (!section) return;
    var root = section.classList.contains('rt-product-carousel-section')
      ? section
      : section.querySelector('.rt-product-carousel-section');
    var count = section.querySelectorAll('.rt-product-carousel__page > .grid-product').length;
    sync(root, count);
  });
})();
